import { graphql } from 'react-relay';

export const linkListGroupFragment = graphql`
    fragment LinkListGroup_frontGroup on LinkListGroup {
        title
        linkLists {
            ...LinkList_linkList
        }
    }
`;
